<template>
  <div class="app-container home">
    <div class="text1">WELCOME</div>
    <div class="text2">欢迎进入鑫源全球客户服务管理平台</div>
  </div>
</template>

<script>
import { setSession, getSession } from "@/util/localStor";
import { getNations, getCountries } from "@/api/api";

export default {
  name: "Index",
  data() {
    return {};
  },
  mounted() {
    let obj = getSession("nationList");
    if (JSON.stringify(obj) == "{}") {
      this.getNationList();
    }
    let countryObj = getSession("countryList")
    if (JSON.stringify(countryObj) == '{}') {
      this.getCountryList()
    }
  },
  methods: {
    async getNationList() {
      const res = await getNations();
      if (res.status == 0) {
        setSession("nationList", [{ name: "全部", id: "0" }, ...res.data]);
      }
    },
    async getCountryList() {
      // var id = sessionStorage.getItem('staffAccountId');
      // var params = {
      //   staffId : id
      // }
      const res = await getCountries(); 
      if (res.status == 0) {
        setSession("countryList", res.data);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .text1 {
    font-size: 28px;
    color: #666666;
    line-height: 40px;
  }
  .text2 {
    font-size: 16px;
    color: #666666;
    line-height: 22px;
  }
}
</style>
